require("./bootstrap");

// Preloader
$(window).on("load", function() {
    $(".preloader").fadeOut("slow");
});

$(document).ready(function() {
    $.ajaxSetup({
        headers: {
            "X-CSRF-TOKEN": $('input[name="_token"]').attr("value"),
        },
    });

    $(document).on("click", '[href="#"]', function(e) {
        e.preventDefault();
    });

    // Positive message timeout
    setTimeout(function() {
        $(".message.positive").animate(
            {
                height: "toggle",
                opacity: "toggle",
            },
            500
        );
    }, 5000);

    // Mobile Nav
    $(".toggle-nav").on("click", function(e) {
        e.preventDefault();
        $("nav.navigation").toggleClass("active");
    });

    // Resize YouTube Videos
    var $allVideos = $(
            '.youtube-embed-wrapper iframe[src*="//www.youtube.com"]'
        ),
        $fluidEl = $(".youtube-embed-wrapper");

    $allVideos.each(function() {
        $(this)
            .attr("data-aspectRatio", this.height / this.width)
            .removeAttr("height")
            .removeAttr("width");
    });

    $(window)
        .resize(function() {
            // Mobile Nav
            if (screen && screen.width <= 768) {
                $("header nav ul").removeClass("scroll");
                if (
                    $("header nav").outerHeight() <=
                    $("header nav ul").outerHeight()
                ) {
                    $("header nav ul").addClass("scroll");
                }
            }

            // Resize YouTube Videos
            var newWidth = $fluidEl.width();
            $allVideos.each(function() {
                var $el = $(this);
                $el.width(newWidth).height(
                    newWidth * $el.attr("data-aspectRatio")
                );
            });
        })
        .resize();
});

function thisURL(params) {
    var url,
        thisURL = document.location.pathname;

    if (params === 1) {
        // option = 1 = full page name with all parameters eg: products.php?id_product=1
        thisURLwithParam = thisURL.substring(
            0,
            thisURL.indexOf("#") == -1 ? thisURL.length : thisURL.indexOf("#")
        );
        thisURLwithParam = thisURLwithParam.substring(
            0,
            getPosition(thisURL, "/", 2)
        );
        url = thisURLwithParam;
    } else {
        // option = null = just the page name (eg: products.php)
        thisURL = thisURL.substring(
            0,
            thisURL.indexOf("#") == -1 ? thisURL.length : thisURL.indexOf("#")
        );
        thisURL = thisURL.substring(
            0,
            thisURL.indexOf("?") == -1 ? thisURL.length : thisURL.indexOf("?")
        );
        thisURL = thisURL.substring(0, getPosition(thisURL, "/", 2));
        url = thisURL;
    }

    if (url == "/") {
        url = "/home";
    }

    return url;
}

function thisSubURL(params) {
    var url,
        thisSubURL = document.location.pathname;

    if (params === 1) {
        // option = 1 = full page name with all parameters eg: products.php?id_product=1
        thisURLwithParam = thisSubURL.substring(
            0,
            thisSubURL.indexOf("#") == -1
                ? thisSubURL.length
                : thisSubURL.indexOf("#")
        );
        thisURLwithParam = thisURLwithParam.substring(
            0,
            getPosition(thisSubURL, "/", 3)
        );
        url = thisURLwithParam;
    } else {
        // option = null = just the page name (eg: products.php)
        thisSubURL = thisSubURL.substring(
            0,
            thisSubURL.indexOf("#") == -1
                ? thisSubURL.length
                : thisSubURL.indexOf("#")
        );
        thisSubURL = thisSubURL.substring(
            0,
            thisSubURL.indexOf("?") == -1
                ? thisSubURL.length
                : thisSubURL.indexOf("?")
        );
        thisSubURL = thisSubURL.substring(0, getPosition(thisSubURL, "/", 3));
        url = thisSubURL;
    }

    if (url == "/") {
        url = "/home";
    }

    return url;
}

function getPosition(string, subString, index) {
    return string.split(subString, index).join(subString).length;
}

//Modal
$(document).ready(function(e) {
    //open popup
    $(".download-card__download").on("click", function(event) {
        event.preventDefault();
        $("#email-modal").addClass("is-visible");
        $("#download-file-title").html($(this).data("title"));
        $("#download-file-url").val($(this).data("url"));
    });

    $("#download-file-modal-form").submit(async function(event) {
        event.preventDefault();

        let email = $("#download-file-email").val();
        let url = $("#download-file-url").val();
        let _token = $("#token").val();
        console.log(email, url);

        // api call to back end
        var response = await $.post("/resources", {
            _token: _token,
            email: email,
        });
        window.location.href = url;
    });
    //close popup
    $("#email-modal").on("click", function(event) {
        if (
            $(event.target).is(".close-modal") ||
            $(event.target).is("#email-modal")
        ) {
            event.preventDefault();
            $(this).removeClass("is-visible");
        }
    });
    //close popup when clicking the esc keyboard button
    $(document).keyup(function(event) {
        if (event.which == "27") {
            $("#email-modal").removeClass("is-visible");
        }
    });
});

// Services Sliders

$("#services-sliders").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    arrow: true,
    autoplay: true,
    autoplaySpeed: 4000,
    centerPadding: "0",
    responsive: [
        {
            breakpoint: 900,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                centerMode: true,
                variablewidth: true,
                arrow: false,
                autoplay: true,
                centerPadding: "0",
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrow: true,
                autoplay: true,
                centerPadding: "0",
            },
        },
    ],
});

$("#free-templates-sliders").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    arrow: true,
    autoplay: true,
    autoplaySpeed: 4000,
    centerPadding: "0",
    responsive: [
        {
            breakpoint: 900,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                centerMode: true,
                variablewidth: true,
                arrow: false,
                autoplay: true,
                centerPadding: "0",
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrow: true,
                autoplay: true,
                centerPadding: "0",
            },
        },
    ],
});
